import { TFunction } from "i18next";
import * as Yup from "yup";

export function nullableText(t: TFunction, maxLength: number) {
  return Yup.string()
    .nullable()
    .max(maxLength, ({ max }) => t("common.validation.maxLength", { max }));
}

export function nullableDate(t: TFunction) {
  return Yup.date().nullable().typeError(t("common.validation.invalidDateFormat"));
}

export function nullableAmount(t: TFunction) {
  return Yup.number()
    .nullable()
    .min(0, ({ min }) => t("common.validation.minValue", { min }));
}
